<template>
    <div>
        <div class="webHelp_title">帮助中心</div>

        <!-- 展示 -->
        <div class="exhibit">
            <div class="tit exhibit_title">缩水网帮助中心</div>
            <div>
                <div class="tit">缩水网缩水师免费/付费标准实时动态明细</div>
                <div style="gap: 30px; color: #E9A04B;">
                    <div class="btn" @click="preImg('ssq')">双色球标准动态明细</div>
                    <div class="btn" @click="preImg('dlt')">大乐透标准动态明细</div>
                    <div class="btn" @click="preImg('3d_ps')">3D、排三标准动态明细</div>
                </div>
            </div>
            <div>
                <div class="tit">我想成为缩水师、技巧师、软件交易师</div>
                <div>
                    <div class="btn">注册会员</div>
                    <i class="el-icon-d-arrow-right"></i>

                    <div class="btn btn1">申请缩水师、技巧师、软件师</div>
                    <i class="el-icon-d-arrow-right"></i>

                    <div class="btn">审核通过</div>
                    <i class="el-icon-d-arrow-right"></i>

                    <div class="btn">站内通知</div>
                </div>

            </div>
            <div>
                <div class="tit">我是实体店，想得到平台帮扶</div>
                <div>
                    <div class="btn">注册会员</div>
                    <i class="el-icon-d-arrow-right"></i>

                    <div class="btn btn1">申请实体店帮扶</div>
                    <i class="el-icon-d-arrow-right"></i>

                    <div class="btn">审核通过</div>
                    <i class="el-icon-d-arrow-right"></i>

                    <div class="btn">站内通知</div>
                </div>
            </div>
        </div>

        <div class="webHelp">
            <div class="menu">
                <div class="tit">问题汇总</div>
                <div v-for="(item,index) in help.menu"
                     :key="index"
                     :class="{active:help.active == index}"
                     @click="help.active = index;getList()">
                    {{item.dictLabel}}
                </div>
            </div>

            <div style="flex:1">
                <div class="list"
                     v-loading="listLoading"
                     v-if="list.length">
                    <div v-for="(item, index) in list"
                         :key="index"
                         @click="gotoArticle_details(item,'help')">
                        {{ item.title }}
                    </div>
                </div>

                <div class="emptyData"
                     v-else>暂无内容</div>

                <hxlPagin v-if="list.length"
                          :queryParams="queryParams"
                          @changePage="changePage" />

            </div>
        </div>

        <el-dialog title=""
                   :visible.sync="imgShow"
                   width="50%">

			<img :src="imgUrl" alt="" style="width:100%">

        </el-dialog>

    </div>
</template>

<script>
import hxlPagin from "@/components/hxlPagin";
import ssqImg from "./img/ssq.png";
import dltImg from "./img/dlt.png";
import ps3dImg from "./img/3d_ps.png";
export default {
    components: { hxlPagin },
    data () {
        return {
			imgShow:false,
			imgUrl:'',
			// 静态引入，避免动态 require 解析失败
			imgMap: {
				ssq: ssqImg,
				dlt: dltImg,
				"3d_ps": ps3dImg,
			},

            help: {
                menu: [],
                active: null,
            },

            list: [],
            listLoading: false,

            queryParams: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
        };
    },
    watch: {
        "nav.active" (val) {
            // this.getList(val);
        },
    },
    mounted () {
        this.getHelpType()
    },
    methods: {
		preImg(fileName){
			this.imgShow = true
			this.imgUrl = this.imgMap[fileName] || ''
		},
        changePage (e) { this.queryParams.pageNum = e; this.getList(); },
        gotoArticle_details (item, type) {
            let id = type == 'notice' ? item.noticeId : item.id;
            this.$router.push({
                name: 'article_details',
                query: { id, type }
            })
        },
        getHelpType () {
            this.$utils.getDictionary('pre_help_center_type').then(res => {
                this.help.menu = res.data.map(item => {
                    return {
                        dictLabel: item.dictLabel,
                        dictValue: item.dictValue,
                    }
                })
                this.getList();
            })
        },
        getList () {
            this.listLoading = true

            let type = this.help.active != null ? this.help.menu[this.help.active].dictValue : ''
            let params = {
                ...this.queryParams,
                type,
            }
            this.$http
                .get("/stage-api/pre/center/list?" + this.$utils.getParamByJson(params))
                .then((res) => {
                    this.listLoading = false
                    this.list = res.rows;
                    this.queryParams.total = res.total
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.webHelp_title {
    background-color: #4095e5;
    color: #fff;
    font-weight: bold;
    padding: 10px 20px;
    margin-bottom: 20px;
    font-size: 23px;
}

.exhibit {
    color: #699cc6;
    margin-bottom: 30px;
    .exhibit_title {
        font-weight: bold;
        font-size: 22px;
        border: none;
        padding: 0;
    }
    > div {
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding: 10px 0;
        .tit {
            margin-top: 10px;
            margin-bottom: 10px;
        }
        > div {
            display: flex;
            align-items: center;

            .el-icon-d-arrow-right {
                font-weight: bold;
                margin: 0 10px;
            }
            .btn {
                flex: 1;
                border: 1px solid #699cc6;
                border-radius: 10px;
                text-align: center;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                &.btn1 {
                    flex: 1.5;
                }
            }
        }
    }
}

.webHelp {
    display: flex;
    align-items: flex-start;

    .menu {
        text-align: center;
        margin-right: 30px;
        background-color: #efefef;
        > div {
            line-height: 40px;
            height: 40px;
            font-size: 14px;
            width: 220px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            cursor: pointer;
            &.tit {
                background-color: #4095e5;
                color: #fff;
                font-weight: bold;
                font-size: 20px;
            }
            &.active {
                background-color: rgba(40, 153, 223, 0.5);
                color: #fff;
                &:hover {
                    color: #000;
                }
            }
            &:hover {
                background-color: rgba(40, 153, 223, 0.2);
            }
        }
    }
    .list {
        color: #699cc6;
        > div {
            cursor: pointer;
            padding: 10px;
            border-bottom: 2px dashed rgba(0, 0, 0, 0.2);
            &:hover {
                color: red;
            }
        }
    }
    .emptyData {
        flex: 1;
        text-align: center;
        font-size: 50px;
        color: rgba(0, 0, 0, 0.2);
        font-weight: bold;
        height: 240px;
        line-height: 240px;
    }
}
</style>